



































import { Component, Vue } from "vue-property-decorator";
import { getRoutePath } from "@/router/routes";
import { getPermission } from "@/typescript/lib/common/get_permission";
import { getUsersApi } from "@/typescript/api_client/emesh_api/users/users_api";
import {
  GetUsersResponse,
  GetUserErrorResponse
} from "@/typescript/api_client/emesh_api/users/types";
export { GetUsersResponse, GetUserErrorResponse, getPermission };

@Component
export default class AccountPopupComponent extends Vue {
  isShow: boolean = false;
  user: GetUsersResponse | {} = {};
  isAuthority: boolean = false;

  created() {
    // ユーザー情報を取得した際にエラーが出た場合の画面表示がないため、catch は処理しない
    getUsersApi(this.$store.state.authInfo.user_id).then(
      (resp: GetUsersResponse) => {
        this.user = resp;
        this.$store.commit("setUserInfo", {
          userInfo: resp
        });
      }
    );
    this.isAuthority = getPermission(
      this.$store.state.authInfo.authority
    ).isAdmin;
  }

  getRoutePath(pageName: string): string {
    return getRoutePath(pageName);
  }

  onClickShow() {
    this.isShow = !this.isShow;
  }

  logout() {
    this.$store.commit("setAuthInfo", {
      authInfo: {}
    });
    this.$store.commit("setUserInfo", {
      userInfo: {}
    });
    this.$router.push("/login");
  }

  close() {
    this.isShow = false;
  }
}
